import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  TextField,
  Tooltip,
  Typography,
  Zoom,
} from '@mui/material';
import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../../redux/usersRedux';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  createMicro4Request,
  updateMicro4Request,
} from '../../../redux/microbiologyRedux';
import { loadReportPZ04ByIdRequest } from '../../../redux/reportsPZ04Redux';

const Micro_decision = ({ props }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => getUser(state));
  const { t } = useTranslation();
  const [releaseDecision, setReleaseDecision] = useState(
    props.micro_4_decision ? props.micro_4_decision.releaseDecision : false,
  );
  const [releaseQty, setReleaseQty] = useState(
    props.micro_4_decision ? props.micro_4_decision.releaseQty : '',
  );
  const [withdrawalDecision, setWithdrawalDecision] = useState(
    props.micro_4_decision ? props.micro_4_decision.withdrawalDecision : false,
  );
  const [withdrawalQty, setWithdrawalQty] = useState(
    props.micro_4_decision ? props.micro_4_decision.withdrawalQty : '',
  );
  const [destructionDecision, setDestructionDecision] = useState(
    props.micro_4_decision ? props.micro_4_decision.destructionDecision : false,
  );
  const [destructionQty, setDestructionQty] = useState(
    props.micro_4_decision ? props.micro_4_decision.destructionQty : '',
  );
  const [otherDecision, setOtherDecision] = useState(
    props.micro_4_decision ? props.micro_4_decision.otherDecision : false,
  );
  const [otherDetails, setOtherDetails] = useState(
    props.micro_4_decision ? props.micro_4_decision.otherDetails : '',
  );
  const [decisionDate, setDecisionDate] = useState(
    props.micro_4_decision
      ? dayjs(props.micro_4_decision.decisionDate)
      : dayjs(new Date()),
  );
  const [decisionMaker, setDecisionMaker] = useState(
    props.micro_4_decision
      ? `${props.micro_4_decision.user.firstName} ${props.micro_4_decision.user.lastName}`
      : user.users.firstName + ' ' + user.users.lastName,
  );
  const [reloadReport, setReloadReport] = useState(0);
  const [dataDecision, setDataDecision] = useState(
    props.micro_4_decision ? props.micro_4_decision : false,
  );

  useEffect(() => {
    const start = async () => {
      console.log('Ładowanie danych rozlewu mikrobiologii...');
      const res = await dispatch(loadReportPZ04ByIdRequest(props.id));
      if (res) {
        setDataDecision(
          res.data.micro_4_decision ? res.data.micro_4_decision : false,
        );
        console.log(
          'Dane rozlewu mikrobiologii załadowane:',
          res.data.micro_4_decision,
        );
      }
    };
    start();
  }, [dispatch, props.id, reloadReport]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const micro_4_data = {
      reportPZ04Id: props.id,
      releaseDecision,
      releaseQty: releaseDecision ? releaseQty : '',
      withdrawalDecision,
      withdrawalQty: withdrawalDecision ? withdrawalQty : '',
      destructionDecision,
      destructionQty: destructionDecision ? destructionQty : '',
      otherDecision,
      otherDetails: otherDecision ? otherDetails : '',
      decisionDate,
      userId: user.users.id,
    };

    if (dataDecision) {
      micro_4_data.id = dataDecision.id;
      const res = await dispatch(updateMicro4Request(micro_4_data));
      if (res.status === 200) {
        setReloadReport((prev) => prev + 1);
        console.log('Zaktualizowano decyzję mikrobiologiczną 4', res);
      } else {
        console.log('Błąd aktualizacji decyzji mikrobiologicznej 4', res);
      }
    } else {
      const res = await dispatch(createMicro4Request(micro_4_data));
      if (res.status === 201) {
        setReloadReport((prev) => prev + 1);
        console.log('Dodano decyzję mikrobiologiczną 4', res);
      } else {
        console.log('Błąd dodania decyzji mikrobiologicznej 4', res);
      }
    }
  };
  return (
    <Box sx={{ overflow: 'auto', maxHeight: 'calc(100vh - 200px)' }}>
      <Tooltip
        placement="top"
        slots={{ transition: Zoom }}
        title={
          <Typography>{t('rnModule.stage_4.tooltipDescription')}</Typography>
        }
        style={{ fontSize: '20px' }}
      >
        <Typography
          variant="h6"
          component="h2"
          width="300px"
          gutterBottom
          fontWeight="bold"
          fontStyle="italic"
        >
          {t('rnModule.stage_4.description')}
        </Typography>
      </Tooltip>
      <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
        component={'form'}
        onSubmit={handleSubmit}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Typography variant="h6" component="h2" fontWeight="bold">
            {t('rnModule.stage_4.proceeding')}
          </Typography>
        </Box>
        <Typography variant="h6" component="h2" fontWeight="bold">
          {t('rnModule.stage_4.decision')}
        </Typography>
        <FormGroup sx={{ width: '100%', mb: 2 }}>
          <Box sx={{ display: 'flex' }}>
            <FormControlLabel
              control={<Checkbox />}
              label={t('rnModule.stage_4.decisionRelease')}
              sx={{ width: '450px' }}
              checked={releaseDecision}
              onChange={(e) => setReleaseDecision(e.target.checked)}
            />
            <TextField
              label={t('rnModule.stage_4.qtyHL')}
              value={releaseQty}
              onChange={(e) => setReleaseQty(e.target.value)}
              variant="outlined"
              size="small"
              sx={{ width: '200px', mb: 2 }}
              disabled={!releaseDecision}
            />
          </Box>
          <Box sx={{ display: 'flex' }}>
            <FormControlLabel
              control={<Checkbox />}
              label={t('rnModule.stage_4.decisionBack')}
              sx={{ width: '450px' }}
              checked={withdrawalDecision}
              onChange={(e) => setWithdrawalDecision(e.target.checked)}
            />
            <TextField
              label={t('rnModule.stage_4.qtyHL')}
              variant="outlined"
              size="small"
              sx={{ width: '200px', mb: 2 }}
              disabled={!withdrawalDecision}
              value={withdrawalQty}
              onChange={(e) => setWithdrawalQty(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex' }}>
            <FormControlLabel
              control={<Checkbox />}
              label={t('rnModule.stage_4.decisionDestroy')}
              sx={{ width: '450px' }}
              checked={destructionDecision}
              onChange={(e) => setDestructionDecision(e.target.checked)}
            />
            <TextField
              label={t('rnModule.stage_4.qtyHL')}
              variant="outlined"
              size="small"
              sx={{ width: '200px', mb: 2 }}
              value={destructionQty}
              onChange={(e) => setDestructionQty(e.target.value)}
              disabled={!destructionDecision}
            />
          </Box>
          <Box sx={{ display: 'flex' }}>
            <FormControlLabel
              control={<Checkbox />}
              label={t('rnModule.stage_4.decisionComments')}
              sx={{ width: '450px' }}
              checked={otherDecision}
              onChange={(e) => setOtherDecision(e.target.checked)}
            />
            <TextField
              label={t('rnModule.stage_4.qtyHL')}
              variant="outlined"
              size="small"
              sx={{ width: '200px', mb: 2 }}
              value={otherDetails}
              onChange={(e) => setOtherDetails(e.target.value)}
              disabled={!otherDecision}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              mb: 2,
              justifyContent: 'left',
            }}
          >
            <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD.MM.YYYY"
                views={['year', 'month', 'day']}
                label={t('rnModule.stage_4.dateOfDecision')}
                value={dayjs(decisionDate)}
                onChange={(newValue) => {
                  setDecisionDate(dayjs(newValue));
                }}
                slotProps={{
                  textField: {
                    error: false,
                  },
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <Tooltip
              placement="top"
              slots={{ transition: Zoom }}
              title={
                <Typography>
                  {t('rnModule.stage_4.tooltipDescription')}
                </Typography>
              }
              style={{ fontSize: '20px' }}
            >
              <TextField
                sx={{ width: '25%', ml: 2, mr: 2 }}
                label={t('rnModule.stage_4.decisionMakerSignature')}
                variant="outlined"
                value={decisionMaker}
                disabled
              />
            </Tooltip>
          </Box>
        </FormGroup>

        <Button
          type="submit"
          sx={{
            color: 'white',
            bgcolor: '#C09A53',
            ':hover': { bgcolor: '#9c7c43' },
            height: '40px',
            width: '150px',
            mt: 2,
            mb: 50,
          }}
        >
          {t('rnModule.stage_1.confirmationFirstStep')}
        </Button>
      </Box>
    </Box>
  );
};

export default Micro_decision;
